/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} App_SubtitleInputs */

const cs_app_subtitle = /** @type {(inputs: App_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portál makléře`)
};

const en_app_subtitle = /** @type {(inputs: App_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent portal`)
};

/**
* | output |
* | --- |
* | "Agent portal" |
*
* @param {App_SubtitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const app_subtitle = /** @type {((inputs?: App_SubtitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<App_SubtitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_app_subtitle(inputs)
	return cs_app_subtitle(inputs)
});